import { render } from "./index.vue?vue&type=template&id=a74e4fdc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a74e4fdc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74e4fdc"],['__file',"src/components/BaseUi/MobilePageHeadMenu/src/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a74e4fdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a74e4fdc', __exports__)) {
    api.reload('a74e4fdc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a74e4fdc&scoped=true", () => {
    api.rerender('a74e4fdc', render)
  })

}


export default __exports__